import React from "react";
import ChargerIcon from "../../Common/Svgs/ChargerIcon";
import ViewDetailsIcon from "../../Common/Svgs/ViewDetailsIcon";

const useThreeDotsOptions = () => {
  const options = [
    {
      id: 4,
      value: "View Details",
      icon: (
        <ViewDetailsIcon className="text-dark-gray group-hover:text-black" />
      ),
      hasPermission: true,
    },
    {
      id: 1,
      // value: "Add Battery Energy",
      value: "Add & Swap",
      icon: (
        <ChargerIcon
          size={16}
          className="text-dark-gray group-hover:text-black"
        />
      ),
      hasPermission: true,
    },
    {
      id: 2,
      value: "View Battery Energy",
      icon: (
        <ChargerIcon
          size={16}
          className="text-dark-gray group-hover:text-black"
        />
      ),
      hasPermission: true,
    },
    // {
    //   id: 3,
    //   value: "Move To Hub Station",
    //   icon: (
    //     <HubStationIcon className="text-dark-gray group-hover:text-black" />
    //   ),
    //   hasPermission: usePermission([PERMISSIONS.TRIKE_DISPATCH_AND_MOVE]),
    // },
  ];

  return options;
};

export default useThreeDotsOptions;
